import React, {useRef, useState, useEffect} from 'react';
import {Button, Form} from 'react-bootstrap';
import * as AuthService from '../../services/auth';
import Select from 'react-select';
import {PfButton} from '@profabric/react-components';
import Switch from 'react-bootstrap-switch';
import {useStateWithCallbackLazy} from 'use-state-with-callback';

export default function ModalAddBatch(props) {
  const [hide, setHide] = useState('d-none');
  const [file, setFile] = useState(null);
  const [dropdownCountry, setDropdownCountry] = useState([]);
  const [mode, setMode] = useState('');
  const [disable, setDisable] = useState({
    point: true,
    quota: true,
    country: false,
    campaign: false,
    name: false,
    nickname: false,
    switch: false
  });
  const [error, setError] = useState('');
  const [state, setState] = useStateWithCallbackLazy({
    CAMPAIGN_COUNTRY: '',
    CAMPAIGN_QUOTA_UNIT: '',
    CAMPAIGN: '',
    CAMPAIGN_NAME: '',
    CAMPAIGN_IMG_B64: '',
    CAMPAIGN_ENVIRONMENT: 'PROD',
    CAMPAIGN_POINT: '',
    CAMPAIGN_QUOTA: '',
    CAMPAIGN_NEXT_BATCH: '',
    CAMPAIGN_NICK_NAME: '',
    IS_ACTIVE: 1,
    CAMPAIGN_AMOUNT: ''
  });
  const [isLoading, setLoading] = useState(false);
  const dropdownUnit = [
    {value: 'N', label: 'No limit'},
    {value: 'W', label: 'Week'},
    {value: 'M', label: 'Month'},
    {value: 'Q', label: 'Quarter'},
    {value: 'Y', label: 'Year'}
  ];

  useEffect(() => {
    console.log(props.mode);
    if (props.item !== {} && props.mode === 'refill') {
      setState({...props.item, CAMPAIGN: '', CAMPAIGN_AMOUNT: ''});
    }
    if (props.item !== {} && props.mode === 'update') {
      setDisable((prevState) => ({
        ...prevState,
        country: true,
        campaign: true,
        name: true,
        nickname: true
      }));
      setState(props.item, (state) => {
        if (state.IS_ACTIVE === 1) setHide('overlay dark');
        else setHide('d-none');
      });
    }
    setMode(props.mode);
    downloadDropdownWs();
  }, []);

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (state.CAMPAIGN_COUNTRY === '') {
      formIsValid = false;
      errors = errors + 'Country, ';
    }
    if (state.CAMPAIGN_QUOTA_UNIT === '') {
      formIsValid = false;
      errors = errors + 'Quota Unit, ';
    }
    if (state.CAMPAIGN === '') {
      formIsValid = false;
      errors = errors + 'ID, ';
    }
    if (state.CAMPAIGN_NAME === '') {
      formIsValid = false;
      errors = errors + 'Name, ';
    }
    if (state.CAMPAIGN_NICK_NAME === '') {
      formIsValid = false;
      errors = errors + 'Nickname, ';
    }
    if (state.CAMPAIGN_IMG_B64 === '') {
      formIsValid = false;
      errors = errors + 'Image, ';
    }
    console.log(state.CAMPAIGN_POINT);
    if (state.CAMPAIGN_POINT === '' && state.CAMPAIGN_COUNTRY === 'MY') {
      formIsValid = false;
      errors = errors + 'Exchange, ';
    }
    if (
      state.CAMPAIGN_POINT !== '' &&
      state.CAMPAIGN_POINT !== null &&
      !/^\d+$/.test(state.CAMPAIGN_POINT)
    ) {
      formIsValid = false;
      errors = errors + 'Exchange(number only), ';
    }
    if (state.CAMPAIGN_QUOTA_UNIT !== 'N' && state.CAMPAIGN_QUOTA === '') {
      formIsValid = false;
      errors = errors + 'Quota, ';
    }
    if (
      state.CAMPAIGN_QUOTA_UNIT !== 'N' &&
      !/^\d+$/.test(state.CAMPAIGN_QUOTA)
    ) {
      formIsValid = false;
      errors = errors + 'Quota(number only), ';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    return formIsValid;
  };

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdown();
      const countryDropdown = dropdowns.reduce(function (acc, curr) {
        if (props.mode === 'create' && curr.TYPE === 'COUNTRY_CREATE_BATCH') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        if (props.mode === 'update' && curr.TYPE === 'COUNTRY') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        if (props.mode === 'refill' && curr.TYPE === 'COUNTRY') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        return [...acc];
      }, []);

      setDropdownCountry(countryDropdown);
    } catch (error) {}
  };

  const handleSubmit = async () => {
    if (handleValidation()) {
      setLoading(true);
      try {
        if (mode === 'create') {
          const result = await props.onAdd(state, file);
        }
        if (mode === 'refill') {
          const result = await props.onAdd(
            {...state, IS_ACTIVE: 0, CAMPAIGN_ENVIRONMENT: 'PROD-BATCH'},
            null
          );
        }
        if (mode === 'update') {
          const result = await props.onUpdate(state, null);
        }
        setLoading(false);
      } catch (error) {}
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file); //ปัญหา
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const photoUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const base64 = await convertToBase64(file);
      setState((prevState) => ({...prevState, CAMPAIGN_IMG_B64: base64}));
      setFile(file);
    }
  };

  return (
    <div>
      <Form>
        <div className={hide}>
          <span style={{color: 'white', fontSize: 20}}>
            ACTIVE CAMPAIGN is non-updatable
          </span>
        </div>
        <div className="row">
          <Form.Group className="mb-6 col-md-6">
            <Select
              menuPortalTarget={document.body}
              styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
              isDisabled={disable.country}
              value={dropdownCountry.find(
                (v) => v.value === state.CAMPAIGN_COUNTRY
              )}
              placeholder={'Select Country'}
              options={dropdownCountry}
              id="countryid"
              onChange={(v) => {
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_COUNTRY: v.value
                }));
                if (v.value === 'MY') {
                  setDisable((prevState) => ({...prevState, point: false}));
                } else {
                  setDisable((prevState) => ({...prevState, point: true}));
                  setState((prevState) => ({...prevState, CAMPAIGN_POINT: ''}));
                }
              }}
            />
          </Form.Group>
          <Form.Group className="mb-6 col-md-6">
            <Select
              menuPortalTarget={document.body}
              styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
              value={dropdownUnit.find(
                (v) => v.value === state.CAMPAIGN_QUOTA_UNIT
              )}
              placeholder={'Set Quota Unit'}
              options={dropdownUnit}
              id="unitid"
              onChange={(v) => {
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_QUOTA_UNIT: v.value
                }));
                if (v.value === 'N') {
                  setDisable((prevState) => ({...prevState, quota: true}));
                  setState((prevState) => ({...prevState, CAMPAIGN_QUOTA: ''}));
                } else {
                  setDisable((prevState) => ({...prevState, quota: false}));
                }
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-5">
            <Form.Control
              disabled={disable.campaign}
              value={state.CAMPAIGN}
              name="CAMPAIGN"
              type="text"
              onChange={(event) =>
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN: event.target.value
                }))
              }
              placeholder="campaign id"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-7">
            <Form.Control
              disabled={disable.name}
              value={state.CAMPAIGN_NAME}
              name="CAMPAIGN_NAME"
              type="text"
              onChange={(event) =>
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_NAME: event.target.value
                }))
              }
              placeholder="campaign name"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-5">
            <Form.Control
              name="CAMPAIGN_POINT"
              type="text"
              value={state.CAMPAIGN_POINT}
              disabled={disable.point}
              onChange={(event) =>
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_POINT: event.target.value
                }))
              }
              placeholder="exchange rate"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-7">
            <Form.Control
              disabled={disable.nickname}
              value={state.CAMPAIGN_NICK_NAME}
              name="CAMPAIGN_NICK_NAME"
              type="text"
              onChange={(event) =>
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_NICK_NAME: event.target.value
                }))
              }
              placeholder="campaign nick name"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-3">
            <Button className="col-12" variant="outline-info" disabled>
              240x240
            </Button>
          </Form.Group>
          <Form.Group className="mb-3 col-md-9">
            {/* <Form.Control
              className='custom-file-input'
              type="file"
              accept=".jpef, .png, .jpg"
              onChange={photoUpload}
            /> */}
            <div className="custom-file">
              <input
                type="file"
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                onChange={photoUpload}
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file ? file.name : 'Choose file'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-3">
            <Form.Control
              name="CAMPAIGN_QUOTA"
              type="text"
              value={state.CAMPAIGN_QUOTA}
              disabled={disable.quota}
              onChange={(event) =>
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_QUOTA: event.target.value
                }))
              }
              placeholder="quota"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-4">
            <Form.Control
              name="CAMPAIGN_QUOTA_UNIT"
              type="text"
              value={`/ ${state.CAMPAIGN_QUOTA_UNIT}`}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-4">
            <Form.Control
              disabled={disable.campaign}
              value={state.CAMPAIGN_AMOUNT}
              name="CAMPAIGN_AMOUNT"
              type="text"
              onChange={(event) =>
                setState((prevState) => ({
                  ...prevState,
                  CAMPAIGN_AMOUNT: event.target.value
                }))
              }
              placeholder="amount"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Switch
              disabled={disable.switch}
              onText={'Enable'}
              offText={'Disable'}
              onChange={(el, state) =>
                setState((prevState) => ({
                  ...prevState,
                  IS_ACTIVE: state ? 1 : 0
                }))
              }
              value={state.IS_ACTIVE === 1}
            />
          </Form.Group>
        </div>
      </Form>
      <p className="text-danger">{error}</p>
      <PfButton
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleSubmit}
      >
        {props.title}
      </PfButton>
    </div>
  );
}
